import Qs from "qs";
import { Environment } from "../shared/core/Environment";
import { RequestClass } from "./core/olga/RequestClass";

export default class InternalBenefitAPI {
  client = null;
  environment_id = null;
  token = null;

  constructor() {
    const baseUrl = `${process.env.REACT_APP_SERVICES_ENDPOINT_BASE}`.replace(
      `{SERVICE}`,
      `olga/request/benefits`
    );

    this.client = new RequestClass(baseUrl);
    this.environment_id = Environment.id;
    this.token = Environment.token;
  }


  async getBalanceByCustomerId({ customerId, brandId }) {
    const response = await this.client.get({
      service: 'benefits',
      endpoint: `/internal/brands/${brandId}/customers/${customerId}/cashback/balance`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
        'Cache-Control': 'no-cache',
      },
    });

    const balance = response.getData({ total: 0 });
    return balance.total;
  }

  async getCashbackHistory({ customerId, brandId, term, type, page, limit }) {
    const response = await this.client.get({
      service: 'benefits',
      endpoint: `/internal/brands/${brandId}/customers/${customerId}/cashback/history`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
        'Cache-Control': 'no-cache',
      },
      params: {
        term,
        type,
        page,
        limit
      }
    });

    return response;
  }

  async addCashback({ customerId, brandId, expiresAt, value }) {
    const response = await this.client.put({
      service: 'benefits',
      endpoint: `/internal/brands/${brandId}/customers/${customerId}/cashback`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
      data: { type: 'CREDIT', expiresAt, value  }
    });

    return response;
  }

  async removeCashback({ customerId, brandId, value }) {
    const response = await this.client.put({
      service: 'benefits',
      endpoint: `/internal/brands/${brandId}/customers/${customerId}/cashback`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
      data: { type: 'DEBIT', value  }
    });

    return response;
  }

  async getCouponHistory({ customerId, term, status, page, limit }) {
    const response = await this.client.get({
      service: 'benefits',
      endpoint: `/internal/customers/${customerId}/coupons/history`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
        'Cache-Control': 'no-cache',
      },
      params: {
        term,
        status,
        page,
        limit
      }
    });

    return response;
  }

  async addStandaloneCoupon({ customerId, code, pin }) {
    const response = await this.client.post({
      service: 'benefits',
      endpoint: `/internal/customers/${customerId}/standalone-coupons`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
      },
      data: { code, pin }
    });

    return response;
  }


  async removeCoupon({ customerId, customerCouponId }) {
    const response = await this.client.delete({
      service: 'benefits',
      endpoint: `/internal/customers/${customerId}/coupons/${customerCouponId}`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
      }
    });

    return response;
  }

  async getCustomerBlock (customerId) {
    const response = await this.client.get({
      service: 'benefits',
      endpoint: `/internal/customers/${customerId}/block`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
        'Cache-Control': 'no-cache',
      }
    });

    return response;
  }

  async blockCustomer (customerId ) {
    const response = await this.client.post({
      service: 'benefits',
      endpoint: `/internal/customers/${customerId}/block`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
      }
    });

    return response;
  }

  async unblockCustomer (customerId ) {
    const response = await this.client.delete({
      service: 'benefits',
      endpoint: `/internal/customers/${customerId}/unblock`,
      ignoreVersion: true,
      headers: {
        Authorization: `Bearer ${this.token}`,
      }
    });

    return response;
  }

}
